import React from "react";
import { Stack, Typography } from "@mui/material";

const endDate = "31/08/2023";

const Deadline = () => {
  const getDaysRemaining = () => {
	const endDateArr = endDate.split("/")
    const today = new Date();
    const final = new Date(endDateArr[1]+"/"+endDateArr[0]+"/"+endDateArr[2]);

    const timeDiff = final.getTime() - today.getTime();
	const datsDiff = timeDiff / (1000 * 3600 * 24)
    return Math.ceil(datsDiff);
  };
  return (
    <Stack
      sx={{ p: "10px", width: "100%", height: "100%" }}
      flexDirection={"column"}
      justifyContent={"space-between"}
      alignItems={"flex-start"}
    >
      <Typography sx={{ width: "100%" }} variant="h5" component={"span"}>
        Dias Restantes:
      </Typography>
      <Typography
        sx={{ width: "100%", fontSize:{xs: "50px", md: "80px"} }}
        align="center"
        variant="h1"
        component={"span"}
      >
        {getDaysRemaining()}
      </Typography>
      <Stack
        sx={{
          width: "100%",
          borderTop: "1px solid rgba(255, 255, 255, 0.15)",
          pt: "5px",
		  minHeight: "50px"
        }}
        flexDirection={"row"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Typography
          sx={{
            mr: "10px",
          }}
        >
          El censo finaliza el:
        </Typography>
        <Typography variant="h5" component={"span"}>
          {endDate}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Deadline;
